import {
  Container,
  ContainerLayout,
  LeftSection,
  RightSection,
  StickyPageHeaderSkeleton,
  SupportTicketDetailsLoading,
} from '@/_containers';
import { TicketDetailsRightSectionLoading } from '@/_containers/support/ticket-details/components/right-section/loading';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeleton />
      <Container>
        <LeftSection>
          <SupportTicketDetailsLoading />
        </LeftSection>
        <RightSection>
          <TicketDetailsRightSectionLoading />
        </RightSection>
      </Container>
    </ContainerLayout>
  );
}
